import React from "react";
import { Outlet } from "react-router-dom";
import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { ScrollToTop } from "./ScrollToTop";

export const Layout = () => (
  <>
    <ScrollToTop />
    <NavBar />
    <main><Outlet /></main>
    <Footer />
  </>
);
